import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Mail } from '../Icons';
import { Input, type InputProps } from './Input.component.tsx';

export type EmailInputProps = Omit<InputProps, 'LeftIcon'>;

export const EmailInput: FunctionComponent<EmailInputProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Input
      LeftIcon={Mail}
      placeholder={t('components.EmailInput.placeholder')}
      type="email"
      {...props}
    />
  );
};
